export default __webpack_public_path__ + "static/media/c.e20f90ff.png";